<!--

    Copyright © 2016-2020 The Thingsboard Authors

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

        http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.

-->
<div class="tb-request-password-reset-content mat-app-background tb-dark" fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
  <mat-card fxFlex="initial" class="tb-request-password-reset-card">
    <mat-card-title class="layout-padding">
      <span translate class="mat-headline">login.request-password-reset</span>
    </mat-card-title>
    <mat-progress-bar color="warn" mode="indeterminate" >
    </mat-progress-bar>
    <span style="height: 4px;" ></span>
    <mat-card-content>
      <form [formGroup]="requestPasswordRequest" (ngSubmit)="sendResetPasswordLink()">
        <fieldset>
          <div tb-toast fxLayout="column" class="layout-padding">
            <span style="height: 50px;"></span>
            <mat-form-field class="mat-block">
              <mat-label translate>login.email</mat-label>
              <input matInput type="email" autofocus formControlName="email" email required/>
              <mat-icon class="material-icons" matPrefix>email</mat-icon>
              <mat-error *ngIf="requestPasswordRequest.get('email').invalid">
                {{ 'user.invalid-email-format' | translate }}
              </mat-error>
            </mat-form-field>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="16px" fxLayoutAlign="start center"
                 fxLayoutAlign.gt-xs="center start">
              <button mat-raised-button color="accent" type="submit" >
                {{ 'login.request-password-reset' | translate }}
              </button>
              <button mat-raised-button color="primary" type="button" 
                      routerLink="/login">
                {{ 'action.cancel' | translate }}
              </button>
            </div>
          </div>
        </fieldset>
      </form>
    </mat-card-content>
  </mat-card>
</div>
